module.exports = __webpack_public_path__ + "img/loby-laboratorio-749.a97a07fd.jpg";